/**
 * 슬롯머신 — 규칙 미러 (클라이언트). 서버 `src/game/slot.ts` 와 **같은 값을 내야 한다**(UNI-Q184 · DESIGN 14.265).
 *
 * 화면은 배당표·잭팟 몫 안내를 여기서 읽는다 — 숫자를 문장에 손으로 적으면 서버가 바뀐 날 화면만 옛 값을 말한다.
 * `check-client` 가 동명 상수를, `check-mirror` 가 동명 함수 결과를 대조한다. 결과(릴)는 서버가 정한다.
 * 배당은 **판돈의 몇 배**다 — 아이템 개수가 아니다(사용자 「검 90개 날개 300개는 무슨 뜻이야?」). 화면은 「판돈의 N배」로 적는다.
 * 공동 기금은 은행이다(UNI-Q200): 판돈은 전부 기금에 들어가고 배당·본전은 기금에서 나간다. 한 판 판돈 상한은 없다(2026-10-20).
 */
export const SLOT_SYMBOLS = ['slime', 'potion', 'stone', 'sword', 'wing', 'crown'];
export const SLOT_SYMBOL_KO = { slime: '슬라임', potion: '물약', stone: '강화석', sword: '검', wing: '날개', crown: '왕관' };
export const SLOT_REEL_WEIGHTS = { slime: 14, potion: 10, stone: 7, sword: 4, wing: 2, crown: 1 };
export const SLOT_THREE_MULT = { slime: 4, potion: 10, stone: 26, sword: 90, wing: 300 };
export const SLOT_TWO_SLIME_MULT = 1;
export const SLOT_STAKE_UNIT = 100_000;
export const SLOT_DEFAULTS = { on: true, stakeUnit: SLOT_STAKE_UNIT, fullStake: 10_000_000 };

/** 한 판에 걸 수 있는 최대 배수 — 상한은 없고 산술 안전선(판돈 × 최고 배당이 안전한 정수)만. 서버 slotMaxUnits 와 같다 */
export function slotMaxUnits(cfg) {
  const top = Math.max(...Object.values(SLOT_THREE_MULT));
  return Math.max(1, Math.floor(Number.MAX_SAFE_INTEGER / top / Math.max(1, Number(cfg.stakeUnit))));
}

/** 세 칸 → 배당. 서버 slotEvaluate 와 같다 */
export function slotEvaluate(reels) {
  const [a, b, c] = reels;
  if (a === b && b === c) {
    if (a === 'crown') return { mult: 0, jackpot: true, line: '왕관 셋 — 잭팟' };
    return { mult: SLOT_THREE_MULT[a], jackpot: false, line: `${SLOT_SYMBOL_KO[a]} 셋` };
  }
  if (reels.filter((s) => s === 'slime').length === 2) return { mult: SLOT_TWO_SLIME_MULT, jackpot: false, line: '슬라임 둘' };
  return { mult: 0, jackpot: false, line: '' };
}

/** 잭팟 몫 — 판돈이 기준 이상이면 기금 전부, 아래면 판돈 비율만큼(내림). 서버 slotJackpotShare 와 같다 */
export function slotJackpotShare(fund, stake, fullStake) {
  const f = Math.floor(Number(fund)), s = Math.floor(Number(stake)), full = Math.floor(Number(fullStake));
  if (!Number.isSafeInteger(f) || f <= 0 || !Number.isSafeInteger(s) || s <= 0 || !Number.isSafeInteger(full) || full <= 0) return 0;
  if (s >= full) return f;
  return Number((BigInt(f) * BigInt(s)) / BigInt(full));
}
